import * as React from 'react';
import { Component } from "react";
import Moment from 'react-moment';
import BlueButtonSmall from "../common/BlueButtonSmall"
import { Redirect } from 'react-router-dom';
import UserCheckBox from '../users-list/UserCheckBox'
import ReactResizeDetector from 'react-resize-detector';

export default class UserRow extends Component {

  constructor(props) {
    super(props);
    this. onResize = this.onResize.bind(this);
    this.onClickMessages = this.onClickMessages.bind(this);
    this.onCheckChanged = this.onCheckChanged.bind(this);

    let isCheckBoxChecked = (this.props.sending_list.indexOf(this.props.user.id) === -1) ? false : true;

    this.state = {
      user: this.props.user,
      idx: this.props.idx,
      redirect: false,
      checked: isCheckBoxChecked,
      isMobile: false
    }
  }


  onClickMessages(e) {
    e.preventDefault();
    console.log("onClickMessages")
    console.log(`email: ${this.state.user.email}`);
    console.log(`userId: ${this.state.user.id}`);
    localStorage.setItem("email", this.state.user.email);
    localStorage.setItem("userId", this.state.user.id);
    this.setState({
      redirect: true
    })

  }
 
  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to='/user-messages' />
    }
  }

  onCheckChanged(userId, isChecked) {
    console.log("onCheckChanged userId:" + userId + " - isChecked:" + isChecked)
    this.props.onCheckBoxCallback(userId, isChecked);
  }

   onResize(width, height){
    // console.log("width:"+width)
      this.setState({ isMobile: (width<550)?true:false })
   }

  render() {
    let buttonRow;
    const isMobile = this.state.isMobile;
  //  console.log("isMobile:" + isMobile)
    if (isMobile) {
      buttonRow = <BlueButtonSmall onClick={this.onClickMessages} size="small">Messages</BlueButtonSmall>;
    } else {
      buttonRow = <BlueButtonSmall onClick={this.onClickMessages} size="small"  >Voir Messages</BlueButtonSmall>;
    }
    return (

      <tr key={this.state.idx}>
        <td><UserCheckBox reset={this.state.reset} isChecked={this.state.checked} onCheckChanged={this.onCheckChanged} userId={this.state.user.id} /></td>
        <td>{this.state.user.email}</td>
        {this.renderRedirect()}
        <td><Moment format="DD/MM/YYYY HH:mm" >{this.state.user.createdAt}</Moment></td>
        { /*<td>{this.renderRedirect()}<BlueButtonSmall onClick={this.onClickMessages} size="small"  >Voir Messages</BlueButtonSmall></td> */}
        <td>   <ReactResizeDetector handleWidth handleHeight onResize={this.onResize} /> {buttonRow}</td>

       
      </tr>
    )
  }
}